import React from 'react'
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { formatCurrency } from '../../../../miscellaneous/helpers/utils';
import { addQtyItem, removeFromCart, removeQtyItem } from '../../../../application/actions/cartActions';

import Cart from '../../../../assets/icons/CartBlack.svg'

import './Button.css';
import { t } from '../../../../miscellaneous/language';

const MerchantDetailButton = ({ onMiniCartStateChange }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [isMiniCartOpen, setIsMiniCartOpen] = React.useState(false);

    const { cart } = useSelector((state) => ({
        cart: state.cart
    }));

    const countSumOfQty = () => {
        let total = 0;
        for (var i in cart.items) {
            total += cart.items[i].qty;
        }
        return total;
    }

    const countCartSummary = () => {
        let totalPrice = 0;
        cart.items?.forEach((cartItem) => {
            totalPrice = totalPrice + (cartItem.total_with_addon ? cartItem.total_with_addon * cartItem.qty : cartItem.total * cartItem.qty)
        });

        return totalPrice;
    };

    const handleQtyIncrease = (id) => {
        dispatch(addQtyItem(id));
    };

    const handleQtyDecrease = (id) => {
        const item = cart.items?.find((cartItem) => cartItem.uuid_cart === id);
        if (item?.qty <= 1) {
            dispatch(removeFromCart(id));
        } else {
            dispatch(removeQtyItem(id));
        }
    };

    React.useEffect(() => {
        if (isMiniCartOpen) {
            document.body.style.overflow = 'hidden';
            document.body.style.touchAction = 'none';
        } else {
            document.body.style.overflow = '';
            document.body.style.touchAction = '';
        }

        return () => {
            document.body.style.overflow = '';
            document.body.style.touchAction = '';
        };
    }, [isMiniCartOpen]);

    const openMiniCart = () => setIsMiniCartOpen(true);
    const closeMiniCart = () => setIsMiniCartOpen(false);

    React.useEffect(() => {
        if (onMiniCartStateChange) {
            onMiniCartStateChange(isMiniCartOpen);
        }
    }, [isMiniCartOpen, onMiniCartStateChange]);

    const goToFullCart = () => {
        setIsMiniCartOpen(false);
        history.push('/cart/detail');
    };

    return (
        <>
            {cart.items?.length === 0 ? <div className="none"></div> :
                <>
                    <div className="merchant-detail-button-container" onClick={openMiniCart}>
                        <div className='merchant-detail-button-container-count-item'>
                            <span className="merchant-detail-item-selected">{`${cart.items?.length === 0 ? 0 : countSumOfQty()} ${countSumOfQty() > 1 ? t.text.items : t.text.item}`} | {formatCurrency(countCartSummary())}</span>
                        </div>
                        <div className='merchant-detail-button-container-info'>
                            <div className='merchant-detail-button-container-into-wrap'>
                                <p className="merchant-detail-button">{t.btn.viewCart}</p>
                                <img src={Cart} id="cart-small-icon" />
                            </div>
                        </div>
                    </div>

                    {isMiniCartOpen && (
                        <div className="mini-cart-overlay" onClick={closeMiniCart}>
                            <div className="mini-cart-modal" onClick={(e) => e.stopPropagation()}>
                                <div className="mini-cart-header">
                                    <div>
                                        <p className="mini-cart-title">{t.bottomNav.Cart}</p>
                                        <span className="mini-cart-subtitle">{countSumOfQty()} {countSumOfQty() > 1 ? t.text.items : t.text.item}</span>
                                    </div>
                                    <button type="button" className="mini-cart-close" onClick={closeMiniCart}>×</button>
                                </div>

                                <div className="mini-cart-body">
                                    {cart.items?.length === 0 ? (
                                        <p className="mini-cart-empty">{t.text.emptyCart}</p>
                                    ) : (
                                        cart.items?.map((item) => (
                                            <div className="mini-cart-item" key={item.uuid_cart}>
                                                <div className="mini-cart-item-info">
                                                    <p className="mini-cart-item-name">{item.name}</p>
                                                    <p className="mini-cart-item-price">
                                                        {formatCurrency(item.total_with_addon ? item.total_with_addon * item.qty : item.total * item.qty)}
                                                    </p>
                                                </div>
                                                <div className="mini-cart-qty-controls">
                                                    <button type="button" className="mini-cart-qty-btn" onClick={() => handleQtyDecrease(item.uuid_cart)}>
                                                        −
                                                    </button>
                                                    <span className="mini-cart-qty-value">{item.qty}</span>
                                                    <button type="button" className="mini-cart-qty-btn" onClick={() => handleQtyIncrease(item.uuid_cart)}>
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>

                                <div className="mini-cart-total-row">
                                    <span className="mini-cart-total-label">{t.addon.price}</span>
                                    <span className="mini-cart-total-value">{formatCurrency(countCartSummary())}</span>
                                </div>

                                <div className="mini-cart-footer">
                                    <button type="button" className="mini-cart-view-full" onClick={goToFullCart}>
                                        {t.helmet.desc.DetailCart.split(' ')[0] + ' ' + t.bottomNav.Cart}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            }
        </>
    )
}

export default MerchantDetailButton
